module.exports = "//static.hsappstatic.net/salesImages/static-1.403/crm-images/multiple_deal_pipelines.svg"